import { render, staticRenderFns } from "./PageSettingsFont.vue?vue&type=template&id=3c5ed0c7"
import script from "./PageSettingsFont.vue?vue&type=script&lang=ts"
export * from "./PageSettingsFont.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports